// extracted by mini-css-extract-plugin
export default {"PostPreviewModal":"PostPreviewModal_PostPreviewModal__mBvxA","PostPreviewModalScrollerBg":"PostPreviewModal_PostPreviewModalScrollerBg__3GhB4"};